import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} NotificationData
 * @property {string} title
 * @property {string} description
 * @property {string[]} role_slug
 * @property {number[]} student_ids
 * @property {number[]} user_ids
 * @property {File[]} [media_files]
 */

export const useSendSchoolNotification = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const { axiosInstance } = useAxios();

  const sendNotification = async (notificationData, onSuccess) => {
    try {
      setLoading(true);
      setError("");
      setSuccess(false);

      const formData = new FormData();

      formData.append("title", notificationData.title);
      formData.append("description", notificationData.description);

      /* ================= ROLE SLUG ================= */
      if (notificationData.role_slug?.length) {
        notificationData.role_slug.forEach((role) => {
          formData.append("role_slug[]", role);
        });
      }

      /* ================= STUDENT IDS ================= */
      if (notificationData.student_ids?.length) {
        notificationData.student_ids.forEach((id) => {
          formData.append("student_ids[]", id);
        });
      }

      /* ================= TEACHER IDS ================= */
      if (notificationData.user_ids?.length) {
        notificationData.user_ids.forEach((id) => {
          formData.append("user_ids[]", id);
        });
      }

      /* ================= MEDIA FILES ================= */
      if (notificationData.media_files?.length) {
        notificationData.media_files.forEach((file) => {
          formData.append("media_files[]", file);
        });
      }

      await axiosInstance.post(
        `${TENANT_DOMAIN}/create/annoucement`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      setSuccess(true);
      onSuccess?.();
      return true;
    } catch (err) {
      setSuccess(false);

      if (err?.response?.status === 500 || err?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        const apiErrors = err?.response?.data?.errors;
        const firstError = apiErrors && Object.values(apiErrors)?.[0]?.[0];

        setError(
          firstError || err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN,
        );
      }

      return false;
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, success, sendNotification };
};
